import { FC } from 'react';
import { Button, Link, SxProps, Theme } from '@mui/material';
import { FooterLink, LinkKind, resolveFooterPath } from '@/hooks/footerLinks';
import { useAppContext } from '@/context/App.context';
import { LocalizedNavLink } from '../LocalizedNavLink/LocalizedNavLink';
import { footerActionButton } from './Footer.styles';

export const FooterLinkItem: FC<{ link: FooterLink; sx: SxProps<Theme> }> = ({ link, sx }) => {
  const { isLoggedIn, language } = useAppContext();

  if (link.kind === LinkKind.ACTION) {
    return (
      <Button
        type='button'
        variant='text'
        onClick={link.onClick}
        sx={{ ...footerActionButton, ...sx }}
      >
        {link.label}
      </Button>
    );
  }

  if (link.kind === LinkKind.EXTERNAL) {
    return (
      <Link href={link.href} target='_blank' rel='noopener noreferrer' sx={sx}>
        {link.label}
      </Link>
    );
  }

  const to = resolveFooterPath(link.segment, isLoggedIn);

  if (link.newTab) {
    return (
      <Link href={`/${language}${to}`} target='_blank' rel='noopener noreferrer' sx={sx}>
        {link.label}
      </Link>
    );
  }

  return (
    <Link component={LocalizedNavLink} to={to} underline='none' sx={sx}>
      {link.label}
    </Link>
  );
};
